import React from "react";
import { tt } from "../../../../utils/i18n/i18n";
import Axios from "axios";
import CONFIG from "../../../../model/TSConfig";
import {
  useAccountToDisplaySelector,
  useMasterTokenSelector
} from "../../../../redux/actions/user";
import { buildRedirectURL } from "../../../../utils/helpers/buildRedirectUrl";
import { SIGNUP } from "../../../../utils/routes/routes";
import { useDispatch, useSelector } from "react-redux";
import { RootStateI } from "../../../../redux";
import KC_Button from "../../../../designsystem/KC_Button/KC_Button";
import KC_Toggle from "../../../../designsystem/KC_FormInput/KC_Toggle";
import { setDebug } from "../../../../redux/actions/app";
import { deleteMasterTokenFromStorage } from "../../../../utils/helpers/localStorage";

export default function DebugMenu() {
  const dispatch = useDispatch();

  const isVisible = useSelector((s: RootStateI) => s.app.isDebug);
  const { accountToDisplay } = useAccountToDisplaySelector();
  const masterToken = useMasterTokenSelector();

  const isDebug = useSelector((s: RootStateI) => s.app.isDebug);

  const deleteAccount = async () => {
    if (!masterToken) {
      return;
    }

    try {
      await Axios({
        method: "DELETE",
        url: `${CONFIG.saasBackendUrl}/customers/wipe`,
        headers: { Authorization: `Bearer ${masterToken}` }
      });
      deleteMasterTokenFromStorage();
      window.location.href = buildRedirectURL(SIGNUP, false);
      setTimeout(window.location.reload, 1000);
    } catch (e) {
      alert(tt("error"));
      console.error(e);
    } finally {
      window.location.reload();
    }
  };

  const resetCustomer = async () => {
    if (!masterToken) {
      return;
    }

    try {
      await Axios({
        method: "POST",
        url: `${CONFIG.saasBackendUrl}/customers/reset`,
        headers: { Authorization: `Bearer ${masterToken}` }
      });
      deleteMasterTokenFromStorage();
      window.location.href = buildRedirectURL(SIGNUP, false);
      setTimeout(window.location.reload, 1000);
    } catch (e) {
      alert(tt("error"));
      console.error(e);
    } finally {
      window.location.reload();
    }
  };

  const setPlan = async (plan: string) => {
    if (!accountToDisplay?.trackingID || !accountToDisplay?.token) {
      return;
    }

    try {
      await Axios({
        method: "PUT",
        url: `${CONFIG.saasBackendUrl}/subscription/debug/plan`,
        headers: { Authorization: `Bearer ${accountToDisplay?.token}` },
        params: {
          plan,
          owner: accountToDisplay?.trackingID
        }
      });
      window.location.reload();
    } catch (e) {
      console.error(e);
    } finally {
    }
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="d-flex flex-row p-3 justify-content-center w-100 position-relative debug-menu">
      <div
        className="w-100 h-100"
        style={{
          backgroundColor: "lightgreen",
          opacity: 0.7,
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 1
        }}
      >
        &nbsp;
      </div>
      <div className="d-flex flex-row align-items-center st-gap debug-menu-inner">
        <div className="d-flex flex-row">
          <KC_Toggle
            id="debug"
            isChecked={isDebug}
            onToggle={() => {
              dispatch(setDebug(!isDebug));
            }}
          />
          <span className="d-block ml-2 ">Debug</span>
        </div>

        <KC_Button
          isPrimary
          text={tt("delete_account")}
          onClick={deleteAccount}
          className="d-flex"
        />
        <KC_Button
          isPrimary
          text={tt("reset_account")}
          onClick={resetCustomer}
          className="d-flex"
        />
        <span className="flex-grow-1">{tt("change_plan")}</span>
        <KC_Button
          isPrimary
          text="Amb light"
          onClick={() => setPlan("69b866a25715fc00f60f67af")}
          className="d-flex"
        />
        <KC_Button
          isPrimary
          text="Lty light"
          onClick={() => setPlan("69b9bb4a5715fc00f60f67b8")}
          className="d-flex"
        />
        <KC_Button
          isPrimary
          text="Amb premium"
          onClick={() => setPlan("69ba55cf5715fc00f60f67b9")}
          className="d-flex"
        />
        <KC_Button
          isPrimary
          text="Lty premium"
          onClick={() => setPlan("69ba579c5715fc00f60f67ba")}
          className="d-flex"
        />
        <KC_Button
          isPrimary
          text="Premium"
          onClick={() => setPlan("69ba58025715fc00f60f67bb")}
          className="d-flex"
        />
      </div>
    </div>
  );
}
